import React, { useContext, useState } from 'react';
import {
  HomeContainer,
  HomeContent,
  HomeRow,
  HomeIcon,
  HomeFooter
} from './styles';
import { SecondaryLargeButton } from '../../../components/Buttons/styles';
import colors from '../../../assets/styles/colors';
import { apSecureSteps, apSecureSliderSteps } from '../../../helpers/enum';
import { BsPeople, BsShield } from 'react-icons/bs';
import { P } from '../../../components/Typography/styles';
import Carrousel from '../../../components/Carrousel';
import { ApSecureContext } from '../../../store';

const HomePage = ({ setActiveStep }) => {
  const { apSecure, setApSecure } = useContext(ApSecureContext);
  const [showWelcomeSlider, setWelcomeSlider] = useState(false);

  function setCloseWelcomeModal(bool) {
    setWelcomeSlider(bool);
    setActiveStep(apSecureSteps.CHOSE_OPTION);
  }

  return (
    <HomeContainer>
      <HomeContent>
        <HomeRow>
          <HomeIcon>
            <BsPeople color={colors.white} size={22} />
          </HomeIcon>
          <P color={colors.textPrimary}>El <b>Seguro de Accidentes Personales</b> lo puede adquirir el tomador del crédito.</P>
        </HomeRow>
        <HomeRow>
          <HomeIcon>
            <BsShield color={colors.white} size={22} />
          </HomeIcon>
          <P color={colors.textPrimary}>Es importante brindar al cliente la información acerca de las principales coberturas, que se nombran a continuación.</P>
        </HomeRow>
        <HomeFooter>
        <SecondaryLargeButton type="button" id="button" onClick={() => setWelcomeSlider(true)}>Ver beneficios</SecondaryLargeButton>
        </HomeFooter>
      </HomeContent>
      {showWelcomeSlider && <Carrousel setShow={setCloseWelcomeModal} steps={apSecureSliderSteps} header={`${apSecure.solicitation?.cliente.nombres} ${apSecure.solicitation?.cliente.tipoIdentificacion.toUpperCase()}. ${apSecure.solicitation?.cliente.identificacion}`} />}
    </HomeContainer>
  )
}

export default HomePage;
